import { NumberField, NumberFieldProps } from './number-field';
import { FieldValues, Path } from 'react-hook-form';

export interface EurorepairTotalFieldProps<T extends FieldValues = FieldValues>
  extends Omit<NumberFieldProps<T>, 'name'> {
  name?: Path<T>;
}

export const EurorepairTotalField = <T extends FieldValues = FieldValues>({
  name = 'euroRepairPrice' as Path<T>,
  ...rest
}: EurorepairTotalFieldProps<T>) => {
  return <NumberField name={name} {...rest} isSmallSize allowNegative={false} />;
};
